import { RootState } from '@/store/types';
import { ActionTree } from 'vuex';
import { LoadingState } from './types';

export const actions: ActionTree<LoadingState, RootState> = {};
